module.exports = __webpack_public_path__ + "static/img/1-1.c10b5a90.png";